<template>
    <div>
        <block v-if="loading"/>
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
                <v-btn
                    class="btn-save mr-1"
                    small
                    v-if="$store.getters['rolesUser/getCustomRole'](194)"
                    @click.prevent="updateAcountConfig"
                >
                    <v-icon>
                        mdi-content-save
                    </v-icon>
                   
                </v-btn>
            </div>
        </v-card>
        <div>
            <v-tabs
                v-model="panel"
                background-color="transparent"
                grow
                
                >
            
                <v-tab
                    v-for="tab in showTabs"
                    :key="tab.Type"
                    :href="'#tab-'+tab.Type"
                    
                    >
                    {{ tab.Name }}
                </v-tab>

            </v-tabs>
            <v-tabs-items v-model="panel">
                <v-tab-item
                    v-for="tab in showTabs"
                    :value="'tab-'+tab.Type"
                    :key="tab.Type"
                    >
                    <template v-if="tab.Type === '2' ">
                        <div class="groupbox" >
                            <v-radio-group  v-model="tab.group" row>
                                <v-radio
                            
                                    label="Por Metodo de pago"
                                    value="1"
                                ></v-radio>
                                <v-radio
                            
                                    label="Por Estado de la factura"
                                    value="2"
                                ></v-radio>
                            </v-radio-group>
                            <div  v-for="data,index in tab.childs" :key="index"  >
                                <v-row v-if="data.box && tab.group == data.box" >
                                    <v-col cols="12" md="5">
                                        <v-card-title>
                                            {{ data.Name }}
                                        </v-card-title>
                                    </v-col>
                                    <v-col class="mt-2" cols="12" md="5">
                                        <v-text-field
                                            v-model="data.value"
                                            :ref="`${data.Name}${data.Type}`"
                                            label="Numero de Cuenta"
                                            outlined
                                            disabled
                                            dense
                                            @input="validateNumeber"
                                            ></v-text-field>
                                    </v-col>
                                    <v-col class="mt-2 d-flex justify-center" cols="12" md="2">
                                        <v-btn
                                            class="btn-save"
                                            v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                            small
                                            @click="showModel = true; itemSelected = data; isAllowTransaction = false"
                                            >
                                            <v-icon>
                                                mdi-magnify
                                            </v-icon>
                                        </v-btn>
                                        <v-btn
                                            class="btndelete ml-2"
                                            v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                            small
                                            @click="deleteInput(data)"
                                            >
                                            <v-icon>
                                                mdi-close
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </template>
                    <v-row class="mt-3" v-for="data,index in tab.childs" :key="index">
                        
                        <template v-if="!data.box">
                            <v-col cols="12" md="5">
                                <v-card-title>
                                    {{ data.Name }}
                                </v-card-title>
                            </v-col>
                            <v-col class="mt-2" cols="12" md="5">
                                <v-text-field
                                    v-model="data.value"
                                    :ref="`${data.Name}${data.Type}`"
                                    label="Numero de Cuenta"
                                    outlined
                                    dense
                                    disabled
                                    @input="validateNumeber"
                                    ></v-text-field>
                            </v-col>
                            <v-col class="mt-2 d-flex justify-center" cols="12" md="2">
                                <v-btn
                                    class="btn-save"
                                    v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                    small
                                    @click="showModel = true; itemSelected = data; isAllowTransaction = false"
                                    >
                                    <v-icon>
                                        mdi-magnify
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    class="btndelete ml-2"
                                    v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                    small
                                    @click="deleteInput(data)"
                                    >
                                    <v-icon>
                                        mdi-close
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </template>
                        
                    </v-row>

                    <template v-if="tab.Type === '4' ">
                        <div class="groupbox" >
                            <h3 class="text-md-subtitle-3">Cuentas para Estado de Resultados</h3>
                            <v-row v-for="data,index in accountTabsFourInBox" :key="index"  >
                                <v-col cols="12" md="5">
                                    <v-card-title>
                                        {{ data.Name }}
                                    </v-card-title>
                                </v-col>
                                <v-col class="mt-2" cols="12" md="5">
                                    <v-text-field
                                        v-model="data.value"
                                        :ref="`${data.Name}${data.Type}`"
                                        label="Numero de Cuenta"
                                        outlined
                                        disabled
                                        dense
                                        @input="validateNumeber"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="mt-2 d-flex justify-center" cols="12" md="2">
                                    <v-btn
                                        class="btn-save"
                                        v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                        small
                                        @click="showModel = true; itemSelected = data; isAllowTransaction = true"
                                        >
                                        <v-icon>
                                            mdi-magnify
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="btndelete ml-2"
                                        v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                        small
                                        @click="deleteInput(data)"
                                        >
                                        <v-icon>
                                            mdi-close
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </template>

                    <template v-if="tab.Type === '5' ">
                        <div class="groupbox" >
                            <h3 class="text-md-subtitle-3">Cuentas para Estado de Resultados</h3>
                            <v-row v-for="data,index in accountTabsFiveInBox" :key="index"  >
                                <v-col cols="12" md="5">
                                    <v-card-title>
                                        {{ data.Name }}
                                    </v-card-title>
                                </v-col>
                                <v-col class="mt-2" cols="12" md="5">
                                    <v-text-field
                                        v-model="data.value"
                                        :ref="`${data.Name}${data.Type}`"
                                        label="Numero de Cuenta"
                                        outlined
                                        disabled
                                        dense
                                        @input="validateNumeber"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="mt-2 d-flex justify-center" cols="12" md="2">
                                    <v-btn
                                        class="btn-save"
                                        v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                        small
                                        @click="showModel = true; itemSelected = data; isAllowTransaction = true"
                                        >
                                        <v-icon>
                                            mdi-magnify
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="btndelete ml-2"
                                        v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                        small
                                        @click="deleteInput(data)"
                                        >
                                        <v-icon>
                                            mdi-close
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="groupbox" >
                            <h3 class="text-md-subtitle-3">Cuentas para Partidas de Cierre</h3>
                            <v-row v-for="data,index in accountTabsSixInBox" :key="index"  >
                                <v-col cols="12" md="5">
                                    <v-card-title>
                                        {{ data.Name }}
                                    </v-card-title>
                                </v-col>
                                <v-col class="mt-2" cols="12" md="5">
                                    <v-text-field
                                        v-model="data.value"
                                        :ref="`${data.Name}${data.Type}`"
                                        label="Numero de Cuenta"
                                        outlined
                                        disabled
                                        dense
                                        @input="validateNumeber"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="mt-2 d-flex justify-center" cols="12" md="2">
                                    <v-btn
                                        class="btn-save"
                                        v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                        small
                                        @click="showModel = true; itemSelected = data; isAllowTransaction = true"
                                        >
                                        <v-icon>
                                            mdi-magnify
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="btndelete ml-2"
                                        v-if="$store.getters['rolesUser/getCustomRole'](tab.id_update)"
                                        small
                                        @click="deleteInput(data)"
                                        >
                                        <v-icon>
                                            mdi-close
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                    
                   
                </v-tab-item>
                
            </v-tabs-items>
        </div>
        <v-dialog v-model="showModel" width="60%">
                <v-card>
                  <AccountingItemForm :win="win"
                  v-on:sendSelection="reaciveSelection"
                  :isAllowTransaction="isAllowTransaction"
                  />
                </v-card>
        </v-dialog>

        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        />
    </div>
</template>

<script>
    //import {mapState} from 'vuex';
    import Alerts from "@/components/Alerts";
    import AccountingItemForm from './AccountingItemForm.vue';
    import Block from "@/components/Block.vue";
    export default {
        name: "AccountParams",
        components: {
            AccountingItemForm,
            Alerts,
            Block
        },
        props: ['win'],
        data() {
            return {
                isAllowTransaction: false,
                keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
                DataTable: [],
                loading: false,
                alert: {
                    type: "success",
                    show: false,
                    header: "",
                    body: "",
                },
                panel: 0,
                showModel: false,
                tab: null,
                itemSelected: null,
                key: 0,
                Accounts: [
                    {
                        Type: '1',
                        Name: 'Cuenta para Pago o Provision (Costos)',
                        value: null,
                        dbName: 'purchase_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Cuentas por Pagar (Costos)',
                        value: null,
                        dbName: 'purchase_credit_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Pago o Provision (Gastos)',
                        value: null,
                        dbName: 'expense_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Cuentas por Pagar (Gastos)',
                        value: null,
                        dbName: 'expense_credit_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Crédito Fiscal',
                        value: null,
                        dbName: 'purchase_iva_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta Percepción Iva',
                        value: null,
                        dbName: 'purchases_perceptions_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta Retencion Iva',
                        value: null,
                        dbName: 'purchases_withholdings_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta Retencion Renta',
                        value: null,
                        dbName: 'provisions_rent_holdings_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Seguro sobre Facturas de Exportación',
                        value: null,
                        dbName: 'purchases_export_invoice_insurance_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Flete de Facturas de Exportación',
                        value: null,
                        dbName: 'purchases_export_invoice_freight_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Fovial (Hidrocarburos)',
                        value: null,
                        dbName: 'purchases_fovial_hidrocarbons_id_account'
                    },
                    {
                        Type: '1',
                        Name: 'Cuenta para Cotrans (Hidrocarburos)',
                        value: null,
                        dbName: 'purchases_cotrans_hidrocarbons_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta para Ventas al contado',
                        value: null,
                        dbName : 'sales_id_account_counted',
                        box: '2'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta para Ventas al credito',
                        value: null,
                        dbName : 'sales_id_account_credit',
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta Debito Fiscal Contribuyente',
                        value: null,
                        dbName : 'taxpayer_tax_debit_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta Debido Fiscal Consumidor Final',
                        value: null,
                        dbName : 'final_customer_tax_debit_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta Percepción Iva',
                        value: null,
                        dbName: 'perceptions_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta Retencion Iva',
                        value: null,
                        dbName: 'withholdings_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta para Seguro sobre Facturas de Exportación',
                        value: null,
                        dbName: 'sales_export_invoice_insurance_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta para Flete de Facturas de Exportación',
                        value: null,
                        dbName: 'sales_export_invoice_freight_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta para Fovial (Hidrocarburos)',
                        value: null,
                        dbName: 'sales_fovial_hidrocarbons_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta para Cotrans (Hidrocarburos)',
                        value: null,
                        dbName: 'sales_cotrans_hidrocarbons_id_account'
                    },
                    {
                        Type: '2',
                        Name: 'Cuenta ventas no Sujetas',
                        value: null,
                    },
                    {
                        Type: '3',
                        Name: 'Cuenta para Anticipo a Cuenta IVA 2%',
                        value: null,
                        dbName: 'sd_AnticipoCuentaIVA2Percent'
                    },
                    {
                        Type: '3',
                        Name: 'Cuenta de Gasto por Comisiones',
                        value: null,
                        dbName: 'sd_GastoComision'
                    },
                    {
                        Type: '3',
                        Name: 'Cuenta General de Cuentas por Cobrar',
                        value: null,
                        dbName: 'sd_CuentasPorCobrar'
                    },
                    {
                        Type: '4',
                        Name: 'Reporte y Balance de Activos',
                        value: null,
                        dbName: 'reports_and_balances_a',
                        box: '3',
                    },
                    {
                        Type: '4',
                        Name: 'Reporte y Balance de Pasivos',
                        value: null,
                        dbName: 'reports_and_balances_p',
                        box: '3',
                    },
                    {
                        Type: '4',
                        Name: 'Reporte y Balance de Patrimonio Neto',
                        value: null,
                        dbName: 'reports_and_balances_nw',
                        box: '3',
                    },
                    {
                        Type: '4',
                        Name: 'Reporte y Balance de Cuentas de Resultados Deudoras',
                        value: null,
                        dbName: 'reports_and_balances_dis',
                        box: '3',
                    },
                    {
                        Type: '4',
                        Name: 'Reporte y Balance de Cuentas de Resultados Acreedoras',
                        value: null,
                        dbName: 'reports_and_balances_cis',
                        box: '3',
                    },
                    {
                        Type: '4',
                        Name: 'Reporte y Balance de Cuentas de Memorandum Deudoras',
                        value: null,
                        dbName: 'reports_and_balances_dmr',
                        box: '3',
                    },
                    {
                        Type: '4',
                        Name: 'Reporte y Balance de Cuentas de Memorandum Acreedoras',
                        value: null,
                        dbName: 'reports_and_balances_cmr',
                        box: '3',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Ingreso Operacionales',
                        value: null,
                        dbName: 'result_statement_oi', // operational incomes
                        box: '5',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Otros Ingresos no Operacionales',
                        value: null,
                        dbName: 'result_statement_anoi', // another no operational incomes
                        box: '5',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Costos Devoluciones y Rebajas Sobre Ventas',
                        value: null,
                        dbName: 'result_statement_cras', // costs returns and sales
                        box: '5',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Gastos',
                        value: null,
                        dbName: 'result_statement_os', // operational spents
                        box: '5',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Reserva Legal',
                        value: null,
                        dbName: 'result_statement_lr', // legal reserve
                        box: '5',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Capital Social',
                        value: null,
                        dbName: 'result_statement_sc', // capital social
                        box: '5',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Cierre para Ingresos Operacionales',
                        value: null,
                        dbName: 'settlement_entry_oi', // operational incomes
                        box: '6',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Cierre para Ingresos no Operacionales',
                        value: null,
                        dbName: 'settlement_entry_anoi', // another no operational incomes
                        box: '6',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Cierre para Costos Devoluciones y Rebajas Sobre Ventas',
                        value: null,
                        dbName: 'settlement_entry_cras', // costs returns and sales
                        box: '6',
                    },
                    {
                        Type: '5',
                        Name: 'Cuenta de Cierre para Gastos Operacionales y no Operacionales',
                        value: null,
                        dbName: 'settlement_entry_expenses', // operational spents
                        box: '6',
                    }
                ],
                TabsToShow:[
                    {
                        Type: '1',
                        id_view: 188,
                        id_update: 189,
                        Name: 'Cuentas Para Provisiones',
                        childs:[]
                      
                    },
                    {
                        Type: '2',
                        id_view: 190,  
                        id_update: 191,
                        Name: 'Cuentas para Ventas',
                        childs:[],
                        group: '1'
                       
                    },
                    {
                        Type: '3',
                        id_view: 195,
                        id_update: 196,
                        Name: 'Cuentas para Documentos de Liquidación',
                        childs:[]
                    },
                    {
                        Type: '4',
                        id_view: 194,  
                        id_update: 195,
                        Name: 'Cuentas de activos',
                        childs:[],
                       
                    },
                    {
                        Type: '5',
                        id_view: 192,
                        id_update: 193,
                        Name: 'Otras Cuentas',
                        childs:[]
                    },
                ],
                AcountList: [],
                Payments: []
            }
        },
        computed:{
            accountTabsFourInBox(){
                return this.Accounts.filter(account => account.Type == '4')
            },
            accountTabsFiveInBox(){
                return this.Accounts.filter(account => account.Type == '5' && account.box == '5')
            },
            accountTabsSixInBox(){
                return this.Accounts.filter(account => account.Type == '5' && account.box == '6')
            },
            showTabs(){
             
                return this.TabsToShow.filter(tab => this.$store.getters['rolesUser/getCustomRole'](tab.id_view))
            }
            
        },
        methods: {
            deleteInput (data) {
                this.TabsToShow.forEach(element => {
                    element.childs.forEach(child => {
                        // Comparar usando múltiples criterios para identificar exactamente el elemento correcto
                        // console.log('this.isSameAccount', this.isSameAccount);
                        if(this.isSameAccount(child, data)){
                            child.id = null;
                            child.value = '';
                        }
                    });
                });
            },
            async getAllAcounts(){
                try {
                    const result = await this.$API.branchaccountcatalog.getActiveBranchAccountCatalog();
                    this.AcountList = result.data;
                   
                } catch (error) {
                    console.log(error);
                }
            },
            async getAcountConfig(){
                try{
                    const data = await this.$API.branchaccountconfig.getBranchAccountsConfig()
                    if( !data.data ) {
                        this.DataTable = {
                            ID_Business: JSON.parse(localStorage.getItem('user')).businessid,
                            ID_Branch: JSON.parse(localStorage.getItem('user')).branch,
                        }
                    } else {
                        this.DataTable = data.data.config;
                        this.Payments = data.data.paymentmethods;
                    }
                }
                catch(error){
                    console.log(error);
                }
            },
            closeAlert() {
                this.alert.show = false;

            },
            acceptAlert() {
                this.alert.show = false;

      
            },
            showAlert(type, header, body, options = null) {
                type = type == null ? "danger" : type;
                this.alert.type = type;
                this.alert.header = header;
                this.alert.body = body;
                this.alert.show = true;
                this.alert.options = options != null ? options : null;
            },
            async updateAcountConfig(){
                try{
                    this.loading = true;
                    const body = {
                        branch_account_config: {},
                        payment_method_config: []
                    };
                    for (const element of this.TabsToShow) {
                        for (const child of element.childs) {
                            if (child.dbName) {
                                // console.log(child);
                                body.branch_account_config[child.dbName] = child.id || null;
                            }
                            if (child.box === '1') {
                                body.payment_method_config.push({
                                    id_payment_method: child.dbStr,
                                    id_account: child.id
                                });
                            }
                        }
                    }

                    const activeAccount = this.filterEmptyActiveAccountAttribute();

                    if(activeAccount.length > 0){
                        this.showAlert('info','Atención','Se guardaran los cambios y algunos campos de cuentas de activos están vacíos.');
                    }

                    await this.$API.branchaccountconfig.UpdateBranchAccountsConfig(body)
                    this.loading = false;
                    this.setupComponent();
                    this.showAlert('success','Exito','Se ha actualizado la configuracion de cuentas');
                }
                catch(error){
                    this.loading = false;
                    console.log(error);
                }
            },
            filterEmptyActiveAccountAttribute(){
                return this.Accounts.filter(account => {
                    if (account.Type === '3' && account.value === null) {
                        account.value = null;
                    }
                    return account;
                });
            },
            AssignChilds(){

                this.Accounts.forEach(element => {
                    // Verificar si el elemento actual tiene la propiedad 'dbName'
                    // console.log(element.dbName);
                    if(element.dbName && element.dbName in this.DataTable & this.AcountList?.length > 0) {
                        this.AcountList.forEach(account => {
                            if(account.id_account == this.DataTable[element.dbName]){
                                element.id = account.id_account;
                                element.value = account.account_code;
                            }
                           
                        });
                        
                        
                    }
                    if(element.dbStr ){
                        const reg = this.Payments.find(x=>x.InvoicePaymentType == element.dbStr);
                        if(reg){
                            this.AcountList.forEach(account => {
                                if(account.id_account == reg.id_account){
                                    element.id = account.id_account;
                                    element.value = account.account_code;
                                }
                            });
                        }
                    }
                });


                this.TabsToShow.forEach(element => {
                    element.childs = this.Accounts.filter(x=>x.Type == element.Type)
                });
            },
            reaciveSelection(data){
                this.showModel = false;
                console.log(data);
                // Buscar el elemento específico usando una comparación más precisa
                this.TabsToShow.forEach(element => {
                    element.childs.forEach(child => {
                        // Comparar usando múltiples criterios para identificar exactamente el elemento correcto
                        if(this.isSameAccount(child, this.itemSelected)){
                            child.id = data.id_account;
                            child.value = data.account_code
                        }
                    });
                });
            },
            isSameAccount(account1, account2) {
                // Primero verificar si son exactamente el mismo objeto en memoria
                if (account1 === account2) {
                    return true;
                }
                
                // Si ambos tienen dbName, compararlos junto con el Type
                if (account1.dbName && account2.dbName) {
                    return account1.dbName === account2.dbName && account1.Type === account2.Type;
                }
                
                // Si tienen dbStr (métodos de pago), compararlos
                if (account1.dbStr && account2.dbStr) {
                    return account1.dbStr === account2.dbStr && account1.Type === account2.Type;
                }
                
                // Si no tienen identificadores únicos, comparar por Name y Type
                return account1.Name === account2.Name && account1.Type === account2.Type;
            },
            async setupComponent() {
                try {
                    this.getPaymethods();
                    await this.getAllAcounts();
                    await this.getAcountConfig();
                    await this.AssignChilds();
                } catch (error) {
                    console.log(error);
                }

            },
            getPaymethods(){
                const data =  this.$store.getters['getCatalogMH']('FormaPago');
                console.log( 'forma pago data ', data );
                if (data.length > 0) {
                    data.forEach(element => {
                        let valores = element.Valores;
                        let valoresName = element.Valores;
                        if (valores === 'Tarjeta Débito' && this.keyMaster === '47770e9a83f6f46af2a3d2b93fff710a') {
                            valoresName = 'POS DAVIVIENDA'
                        }
                        if (valores === 'Tarjeta Crédito' && this.keyMaster === '47770e9a83f6f46af2a3d2b93fff710a') {
                            valoresName = 'POS CREDOMATIC'
                        }

                        const Current = this.Accounts.find(x=>x.dbStr == element.Valores);
                        if(!Current) 
                        this.Accounts.push({
                           Type: '2',
                           Name: 'Cuenta para ' + valoresName,
                           value: null,
                           box: '1',
                           dbStr: valores,

                        });  
                    });
                   
                }
            },
            async validateNumeber(){
               
                for(let i = 0; i < this.TabsToShow.length; i++ ){
                    for(let j = 0; j < this.TabsToShow[i].childs.length; j++){
                        
                        
                           
                            await this.$nextTick(()=>{
                                
                                this.TabsToShow[i].childs[j].value = this.TabsToShow[i].childs[j].value.replace(/[^0-9]/g, "");
                
                            })
                        }
                    }
                


                
                
                
            },
           
        },
        mounted() {
            this.setupComponent();
            
        },

    }
</script>

<style scoped>
.bar {
  width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin-top: 1rem !important;
}

.groupbox {
  border-width: 2px; /* Grosor del borde */
  border-style: solid; /* Estilo del borde, en este caso sólido */
  border-color: #000; /* Color del borde, en este caso negro */
  border-radius: 15px;
  padding: 16px;
  margin-top: 10px;
}

.btn-add{
  background-color: #3498DB  !important;
  color: white;
}
.btnsave{
  background-color: #00A178 !important;
  color: white;
}
.btnclean{
  background-color: #F29D35 !important;
  color: white;
}
btndelete{
  background-color: #E3191E !important;
  color: white;
}


</style>